// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "productpg/" + {"189":"page-mixAndMatch","404":"page-singleProduct","406":"deferred"}[chunkId] + "." + {"189":"c8f600e004bd049074de","404":"7dbb2e3d693c2a09abf7","406":"60fe18867ee5e446dd54"}[chunkId] + ".css";
};